import React from "react"
import { SectionTitleCenter, SectionWrapper } from "../landing-section.styles"
import styled from "styled-components"
import OnboardingImage from "../../../images/img-onboarding.png"
import { QUICKFIN_APP_URL } from "gatsby-env-variables"


export const SectionWhite = styled.section`
  background-color: #fff;
`

export const SectionRegisterWrapper = styled(SectionWrapper)`
  overflow: hidden;

  @media screen and (min-width: 768px) {
    padding-bottom: 0;
  }
`

export const SectionRegisterSubtitle = styled.h4`
  font-size: 16px;
  margin-bottom: 40px;
  line-height: 28px;
  font-family: "Montserrat", sans-serif;
  font-weight: 100;

  @media screen and (min-width: 1100px) {
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 60px;
  }
`

export const SectionRegisterImage = styled.img`
  display: none;
  margin: 0;
  width: 100%;
  box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.3);
  width: calc(100% - 30px);
  margin: 90px 15px 0 15px;

  @media screen and (min-width: 768px) {
    display: block;
  }
`

export const RegisterButton = styled.a`
  font-family: "Open Sans", sans-serif;
  color: #fff;
  border: none;
  background-color: #00c6c7;
  padding: 16px 30px;
  border-radius: 3px;
  font-weight: bold;
  white-space: nowrap;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  text-decoration: none;

  @media screen and (min-width: 1100px) {
    font-size: 20px;
    padding: 20px 40px;
  }
`

export default function SectionRegister() {
  return (
    <SectionWhite>
      <SectionRegisterWrapper>
        <div style={{ textAlign: "center" }}>
          <SectionTitleCenter>
            Cadastro <b>rápido</b>
          </SectionTitleCenter>
          <SectionRegisterSubtitle>
            O cadastro é feito em apenas <b>3 passos</b>, só <br /> precisamos
            de alguns documentos.
          </SectionRegisterSubtitle>
          <RegisterButton href={QUICKFIN_APP_URL + "/acesso/#/criar-conta"}>QUERO ME CADASTRAR</RegisterButton>
          <SectionRegisterImage src={OnboardingImage} />
        </div>
      </SectionRegisterWrapper>
    </SectionWhite>
  )
}
